export default ({
    requestLogin:(login) => ({type:"REQUEST_LOGIN",login}),
    setLogin:(user_detail) => ({type:"SET_LOGIN",user_detail}),
})